import React from 'react';
import { TextField } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  listbox: {
    boxSizing: 'border-box',
    '& ul': {
      padding: 0,
      margin: 0,
    },
  },
});

const AutoCompleteComponent = props => {
  const { onChange, options = [], value, variant = false } = props;
  const classes = useStyles();
  return (
    <Autocomplete
      freeSolo
      // autoSelect={true}
      options={options}
      onChange={onChange}
      value={value}
      style={{ width: 300 }}
      disableListWrap
      classes={classes}
      renderInput={params => (
        <TextField
          {...params}
          // label='Combo box'
          variant={variant}
          InputProps={{ ...params.InputProps, type: 'search' }}
        />
      )}
      // selectOnFocus
      clearOnBlur
      handleHomeEndKeys
    />
  );
};

export default AutoCompleteComponent;
